const STANDARD_STATUSES = new Set([
  "CLEARED",
  "CLEARED_WITH_WARNINGS",
  "NOT_CLEARED",
  "PENDING_CLEARANCE",
]);

const SUCCESS_STATUSES = new Set([
  "REPORTED",
  "REPORTED_WITH_WARNINGS",
  "CLEARED",
  "CLEARED_WITH_WARNINGS",
]);

const STATUS_LABELS = {
  PENDING_SIGNING: "Pending signing",
  SIGNING_FAILED: "Signing failed",
  ZATCA_CHAIN_WAIT: "Waiting for prior invoice",
  HELD: "Held for ZATCA downtime",
  SUBMITTING: "Submitting",
  ZATCA_RETRY_QUEUED: "Queued for retry",
  ZATCA_FAILED_MANUAL: "Needs manual review",
  MANUALLY_HANDLED: "Manually handled",
  REPORTED: "Reported",
  REPORTED_WITH_WARNINGS: "Reported with warnings",
  NOT_REPORTED: "Not reported",
  CLEARED: "Cleared",
  CLEARED_WITH_WARNINGS: "Cleared with warnings",
  NOT_CLEARED: "Not cleared",
  INTERNAL_ONLY: "Internal only",
};

export const isStandardZatcaDocument = (item) =>
  item?.invoice_type === 1 ||
  ([3, 4].includes(item?.invoice_type) && item?.parent_type === 1) ||
  STANDARD_STATUSES.has(String(item?.zatca_status || "").toUpperCase());

export const getZatcaStatusDisplay = (item) => {
  if (item?.onboarding !== 1) {
    return { label: "--", success: null };
  }

  const status = String(item?.zatca_status || "").toUpperCase();
  if (status && STATUS_LABELS[status]) {
    return {
      label: STATUS_LABELS[status],
      success: status === "INTERNAL_ONLY" ? null : SUCCESS_STATUSES.has(status),
    };
  }
  if (item?.signed_xml_url) {
    return {
      label: isStandardZatcaDocument(item) ? "Pending clearance" : "Pending reporting",
      success: false,
    };
  }
  return { label: "Not signed", success: false };
};
